import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEngenheiro'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetByName = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByName/${name}`, data, config)
const GetAll = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAll`, data, config)
const Post = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Post`, data, config)
const Update = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Update`, data, config)
const GetById = (funcionarioid, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetById/${funcionarioid}`, data, config)
const getGridEngenheiro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllPagin?limit=${limit}&index=${index}`, data, config)
const Delete = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Delete`, data, config)

const EngineerRepository = {
  GetByName,
  GetAll,
  Post,
  GetById,
  getGridEngenheiro,
  Delete,
  Update
}

export default EngineerRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/engineer.js